import { render, staticRenderFns } from "./transactionpage.vue?vue&type=template&id=ba8e3ef6&scoped=true&"
import script from "./transactionpage.vue?vue&type=script&lang=js&"
export * from "./transactionpage.vue?vue&type=script&lang=js&"
import style0 from "./transactionpage.vue?vue&type=style&index=0&id=ba8e3ef6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba8e3ef6",
  null
  
)

export default component.exports